<template>
  <div class="dashboard-item status-summary" id="status-summary">
    <div class=" d-flex justify-content-between align-items-center dashboard-item__header">
      <div class="d-flex align-items-center">
        <h4 class="mb-0 p-0 m-0">Status Summary</h4>
        <small-spinner v-if="ui.loading"/>
      </div>
      <div v-if="displayFilter">
        <div class="d-flex">
          <multiselect
            v-model="selectedCampaign"
            placeholder="Campaign"
            id="fieldLender"
            track-by="id"
            label="name"
            class="full-width"
            @select="selectCampaign"
            :options="campaigns"
            :searchable="true"
            :close-on-select="true"
            :allow-empty="false"
            :show-labels="false"
            style="width: 250px;"
          >
          </multiselect>
          <multiselect
            v-model="selectedPeriod"
            placeholder="Period"
            id="fieldLender"
            track-by="value"
            label="label"
            class="full-width ms-2"
            @select="selectPeriod"
            :options="period"
            :searchable="false"
            :close-on-select="true"
            :allow-empty="false"
            :show-labels="false"
          >
          </multiselect>
        </div>
      </div>
    </div>
    <div class="row w-100 status-summary__header">
      <div class="col-3 status-summary__col">
        <span>Select User</span>
      </div>
      <div class="col-3 status-summary__col">
        <span>Status</span>
      </div>
      <div class="col-6 status-summary__col">
        <span>Total No.</span>
      </div>
    </div>
    <div class="status-summary__body">
      <div class="row h-100">
        <div class="col-3 p-0 h-100">
          <div class="status-summary__agents h-100" id="agents">
            <div class="col-12" v-for="(agent, index) in agents" :key="index">
              <div class="status-summary__agent" @click="selectAgent(agent)"
                   :class="{ 'status-summary__agent_active': selectedAgent.id === agent.id }">
                {{ agent.firstName }} {{ agent.lastName }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-9 h-100 p-0">
          <div class="status-summary__statuses" id="statuses">
            <div class="row status-summary__status" v-for="(status, index) in statuses" :key="index">
              <div class="col-6 my-auto ps-4">
                <div class="status-summary__status-name">
                  <span>{{ status.status }}</span>
                </div>
              </div>
              <div class="col-6 my-auto">
                <div class="status-summary__status-count">
                  <span>{{ status.total }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PerfectScrollbar from "perfect-scrollbar";
import Multiselect from "vue-multiselect";
import SmallSpinner from "../../../components/SmallSpinner";

export default {
  name: 'StatusSummaryItems',
  components: {SmallSpinner, Multiselect},
  data() {
    return {
      statuses: [],
      campaigns: [],
      selectedCampaign: {id: null, name: 'All campaigns'},
      allCampaigns: {id: null, name: 'All campaigns'},
      agents: [],
      selectedAgent: null,
      allLeadsCount: 0,
      period: [
        {value: 'today', label: 'Today'},
        // { value: 'yesterday', label: 'Yesterday' },
        {value: 'week', label: 'This week'},
        {value: 'month', label: 'This month'},
        {value: null, label: 'All time'},
      ],
      selectedPeriod: {value: 'today', label: 'Today'},
      displayFilter: false,
      ui: {
        loading: false
      },
    }
  },
  beforeMount() {
    this.selectedAgent = this.isGranted('ROLE_CEO')
      ? {id: null, fullName: 'All Team'}
      : this.$store.getters.getAgent;
    this.getSummary();
  },
  created() {
    this.selectedPeriod = this.period[0];
  },
  methods: {
    getSummary() {
      this.ui.loading = true
      let url = this.selectedAgent.id !== null
        ? `/api/v1/leads/get-summary/agent/${this.selectedAgent.id}`
        : `/api/v1/leads/get-summary/agent`
      this.$http
        .get(url, {
          params: {
            campaign: Number.isInteger(this.selectedCampaign.id) ? this.selectedCampaign.id : null,
            period: typeof this.selectedPeriod === 'object' && this.selectedPeriod !== null ? this.selectedPeriod.value : this.selectedPeriod,
          },
        })
        .then((res) => {
          this.ui.loading = false
          this.campaigns = res.data.campaigns
          this.campaigns.unshift(this.allCampaigns)

          this.agents = res.data.agents
          this.statuses = res.data.statuses

          if (this.isGranted('ROLE_CEO')) {
            this.agents.unshift({id: null, firstName: 'All Team'})
          }

          if (res.data.selectedAgent) {
            this.selectedAgent = res.data.selectedAgent
          } else {
            this.selectedAgent = {id: null, fullName: 'All Team'}
          }

          this.allLeadsCount = res.data.allLeadsCount
          this.selectedPeriod = {
            value: res.data.selectedPeriod,
            label: res.data.selectedPeriod[0].toUpperCase() + res.data.selectedPeriod.substring(1)
          }
          this.displayFilter = true

          this.$nextTick(() => {
            const scrollbarStatusSummary = document.getElementById('statuses')
            const scrollbarStatuses = document.getElementById('agents')

            this.ui.psStatus = new PerfectScrollbar(scrollbarStatusSummary)

            this.ui.psStatuses = new PerfectScrollbar(scrollbarStatuses)
          })
        })
        .catch((err) => console.log(err))
    },
    selectAgent(agent) {
      this.selectedAgent = agent;
      this.getSummary();
    },
    selectCampaign(val) {
      this.selectedCampaign = val;
      this.getSummary();
    },
    selectPeriod(val) {
      this.selectedPeriod = val;
      this.getSummary();
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .multiselect {
    height: 36px;
    width: 200px;
    min-height: 36px;
    @media screen and (max-width: 568px) {
      max-width: 50%;
      min-width: 100%;
    }

    &.multiselect--active {
      .multiselect__tags {
        transition: all 0.3s;
        border: 1px solid rgba(38, 111, 229, 0.5);
        box-shadow: 0 0 0 4px rgba(38, 111, 229, 0.1);
      }
    }

    &__placeholder {
      display: block;
      color: #000000;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 15px;
      padding-top: 0;
      padding-left: 5px;
    }

    &__tags {
      min-height: 36px;
      max-height: 36px;
      padding: 11px 40px 0 8px;
      transition: all 0.3s;
      border-radius: 8px;
      border: 1px solid #D4D4D4;
      overflow: hidden;

      &:hover {
        border: 1px solid rgba(38, 111, 229, 0.2);
        box-shadow: 0 0 0 4px rgba(38, 111, 229, 0.1);
      }
    }

    &__select {
      min-height: 36px;
      max-height: 36px;

      &:before {
        top: 11%;
        position: relative;
        right: 0;
        color: #999;
        border: solid rgba(0, 0, 0, 1);
        margin-top: 4px;
        border-width: 0 1px 1px 0;
        display: inline-block;
        padding: 3px;
        content: "";
        transform: rotate(44deg);
      }
    }

    &__single {
      color: #000000;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 15px;
      @media screen and (max-width: 568px) {
        font-size: 9px;
        white-space: nowrap;
      }
    }

    &__option {
      padding: 10px 12px;
      min-height: 36px;
      transition: all 0.3s;
      line-height: 20px;
      font-size: 12px !important;
      color: #000;

      &--selected {
        font-size: 12px !important;
      }

      &:hover {
        font-size: 12px;
      }

      @media screen and (max-width: 568px) {
        font-size: 9px;
      }

      &--highlight {
        background: #f3f3f3;
        line-height: 20px;
        font-size: 14px;
        color: #000;
        @media screen and (max-width: 568px) {
          font-size: 9px;
        }
      }
    }
  }
}
</style>
